export default "__VITE_ASSET__D3PhwK_m__"